export type ImmersiveCommand =
  | "enter"
  | "exit-fullscreen"
  | "exit-fallback";

export function immersiveCommand(
  immersive: boolean,
  fullscreenOwnsRoom: boolean,
): ImmersiveCommand {
  if (!immersive) return "enter";
  return fullscreenOwnsRoom ? "exit-fullscreen" : "exit-fallback";
}

export function immersiveControlLabel(immersive: boolean): string {
  return immersive ? "退出沉浸阅读" : "进入沉浸阅读";
}
